<template>
  <div class="mass-rpc_modal">
    <div class="header">
      <h4 class="title">
        Mass RPC Info
      </h4>
    </div>
    <div class="content">
      <div class="params">
        <div class="line">
          <div class="param">
            <label> Команда </label>
            <tree-select
                :options="commands"
                v-model="main_command.command_id"
                placeholder="Команда"
                :clearable="false"
            />
          </div>

          <div class="param">
            <label v-if="command_params !== null"> Параметры </label>
            <tree-select
                v-if="command_params !== null"
                :options="command_params"
                v-model="main_command.command_params_id"
                placeholder="Параметры"
                :clearable="false"
            />
          </div>
        </div>

        <div class="line">
          <div class="param timeout">
            <fg-input type="number"
                      :min=0
                      :max=3600
                      v-model="main_command.timeout"
                      placeholder="Таймаут (секунд)"
                      label="Таймаут (секунд)"
            />
          </div>

          <span class="param">
            <WrapDatePicker
                type="datetime"
                value_type="X"
                v-model="main_command.ts_scheduled"
                :range="false"
                format="X"
                label="Запланированное время"
                :clearable="false"
                :disabled_date="['- 1 day', '+ 7 days']"
                :disabled_time="disabled_time"
            />
          </span>
        </div>
      </div>

      <div class="selected_devices" v-if="main_command.device_list.length > 0">
        <p class="center">
          Devices
          {{ main_command.device_list.length > 0 ? '(' + main_command.device_list.length + ')'  : ''}}
        </p>

        <div class="devices">
          <p
              v-for="(device, device_key) in main_command.device_list"
              :key="device_key"
              class="selected_devices__item"
          >
            <span v-html="device.name + ' (' + device.fid + ')'"></span>
            <span @click="delete_device(device.device_id)" class="mdi mdi-close-box" />
          </p>
        </div>


      </div>
    </div>

    <div class="footer">
      <span
          :disabled="check_run_command"
          class="btn btn-info btn-apply btn-fill btn-wd"
          @click.prevent="run_command"
      >
        Отправить
      </span>
      <span
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "Mass_RPC",
  components: {
    WrapDatePicker
  },
  props: ["devices", "list"],
  data () {
    return {
      command_list: [],
      load: false,
      main_command:{
        command_id: null,
        command_params_id: null,
        timeout: null,
        device_list: [],
        ts_scheduled: null
      }
    }
  },
  computed:{
    disabled_time(){
      return new Date();
    },
    commands(){
      return this.command_list.map((command) => {
        return {id: command.id, label: command.name}
      })
    },
    command_params(){
      if (!this.main_command.command_id) return null
      let select_command = this.command_list.find((item) => {
        return item.id === this.main_command.command_id
      })
      if (select_command.command_params === null) return null
      return Object.keys(select_command.command_params).map((index) => {
        return {id: +index, label: select_command.command_params[index].name}
      })
    },
    check_run_command(){
      return this.main_command.command_id == null || this.command_params !== null && this.main_command.command_params_id == null
    }
  },
  watch:{
    "main_command.command_id":{
      deep: false,
      handler(new_val){
        if (new_val !== null){
          let select_command = this.command_list.find((item) => {
            return item.id === this.main_command.command_id
          })
          this.main_command.timeout = select_command.timeout
          this.main_command.command_params_id = select_command.command_params !== null ? Number(Object.keys(select_command.command_params)[0]) : null
        }
      }
    }
  },
  mounted() {
    this.get_command()
    this.main_command.device_list = [...this.devices]
  },
  methods: {
    cancel () {
      this.$emit('close')
    },

    delete_device(dev_id){
      let devices = this.main_command.device_list.filter((device) => {
        if (device.device_id !== dev_id) return device
      })
      this.main_command.device_list = [...devices]
    },

    get_command(){
      this.$http.v1.getMassRPCCommand((response) => {
        this.command_list = response.data
      })
    },

    run_command(){
      if (!this.check_run_command){
        this.load = true
        this.main_command.ts_scheduled = Number(this.main_command.ts_scheduled)
        try{
          this.$http.v1.runMassRPCCommand(this.main_command,(response) => {
            this.global_notify('info', this.translate('device.rpc.success_remote_command'))
            this.$emit('close')
          })
        } catch {
          this.global_notify('danger', this.translate('device.rpc.error_remote_command'))
        }
      }
    },
  }
}

</script>

<style lang='scss' scoped>
.mass-rpc_modal{
  padding: 10px;
  .header{
    padding: 10px 0;
    .title{
      font-size: 22px;
      font-weight: 600;
      margin: 0;
      text-align: center;
    }
  }
  .content{
    padding: 10px 0;
    .line{
      padding: 10px 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;

      .param{
        flex: 3;
        margin-right: 10px;
        .form-group,
        .vue-treeselect{
          margin-bottom: 0;
        }
        .form-control{
          width: 100%;
        }
      }
      .btn{
        margin-bottom: 0;
        height: 40px;
      }
    }
    .selected_devices{
      .devices{
        height: 250px;
        overflow: auto;
      }
      &__item{
        display: inline-block;
        text-wrap: nowrap;
        border: 1px solid #ddd;
        padding: 5px 10px;
        border-radius: 5px;
        margin: 2.5px;
        .mdi{
          cursor: pointer;
          &:hover{
            color: darkred;
          }
        }

      }
    }

  }
  .footer{
    display: flex;
    justify-content: center;
    align-items: center;
    .btn{
      margin: 0 5px;
      display: block;
    }
  }
}

</style>
